import React from 'react';
import { Box, Container } from '@mui/material';

const PublicLayout = ({ children }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f7fb', width: '100%' }}>
      <Container maxWidth={false} disableGutters sx={{ py: 0, px: 0, width: '100%' }}>
        {children}
      </Container>
    </Box>
  );
};

export default PublicLayout;
